import { attributesToProps, domToReact } from 'html-react-parser'

import Box from 'app/components/base/Box'
import Image from 'app/components/base/Image'

export const replaceArticle = (node) => {
  if (node.type === 'tag' && node.name === 'iframe') {
    const attr = attributesToProps(node?.attribs ?? {})

    return (
      <iframe
        {...attr}
        title={attr.title}
        style={{ maxWidth: '100%', width: '100%' }}
      >
        {domToReact(node.children)}
      </iframe>
    )
  }

  if (node.type === 'tag' && node?.name === 'img') {
    const attr = attributesToProps(node?.attribs ?? {})

    return (
      <Box
        component="span"
        sx={{
          position: 'relative',
          display: 'block',
          width: attr?.style?.width ?? '100%',
          maxWidth: '100%',
          height: attr?.style?.height || 'auto'
        }}
      >
        <Image
          {...attr}
          src={attr?.src ?? ''}
          alt={attr?.alt}
          title={attr?.title}
          priority
          layout="fill"
          sizes="(max-width: 899px) 300px, 600px"
          style={{
            width: attr?.style?.width || '80%',
            height: attr?.style?.height || '100%'
          }}
          objectFit="contain"
          objectPosition="center"
          quality={100}
        />
      </Box>
    )
  }
  return node
}
